import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ReactDOM from 'react-dom';

export default function Preloader(props) {
  if (!props.showPreloader) return null;
  return ReactDOM.createPortal(
    <Backdrop
      sx={(theme) => ({
        color: '#fff',
        zIndex: theme.zIndex.modal + 10, // always above dialogs
      })}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>,
    document.body
  );
}
